export default {
  barley: {
    name: 'barley',
    title: 'Barley',
    weight: 10000,
    moisture: 18.5,
    images: {
      '1x': process.env.BASE_URL + '/img/barley.png',
      '2x': process.env.BASE_URL + '/img/barley@2x.png',
    },
  },
  wheat: {
    name: 'wheat',
    title: 'Wheat',
    weight: 10000,
    moisture: 18.5,
    images: {
      '1x': process.env.BASE_URL + '/img/wheat.png',
      '2x': process.env.BASE_URL + '/img/wheat@2x.png',
    },
  },
  beans: {
    name: 'beans',
    title: 'Beans',
    weight: 10000,
    moisture: 18.5,
    images: {
      '1x': process.env.BASE_URL + '/img/beans.png',
      '2x': process.env.BASE_URL + '/img/beans@2x.png',
    },
  },
};
